import { Button } from "@primitives/button";
import { useTranslation } from "react-i18next";
import { useToast } from "@/hooks/useToast";
import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/primitives/dialog";
import { deleteP2PChat } from "@/middleware/chats";

type Props = {
  chatId: string;
  open: boolean;
  onOpenClose: (open: boolean) => void;
};

export default function DeleteP2PChat({ chatId, open, onOpenClose }: Props) {
  const [isLoading, setIsLoading] = useState(false);

  const { t } = useTranslation();
  const { toast } = useToast();

  const handleDeleteP2PChat = async () => {
    if (!chatId) {
      return;
    }
    try {
      setIsLoading(true);
      await deleteP2PChat(chatId);
      toast({
        duration: 1000,
        description: t("chatDeletedSuccessfully"),
        variant: "default",
      });
    } catch (error) {
      toast({
        duration: 1000,
        description:
          error instanceof Error ? error.message : t("errorOccurred"),
        variant: "destructive",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog
      open={open}
      onOpenChange={(isOpen) => {
        if (isLoading) {
          return;
        }
        onOpenClose(isOpen);
      }}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("delete")}</DialogTitle>
          <DialogDescription>
            {t("areYouSure.toDeleteChat")}
            <br></br>
            {t("thisActionCannotBeUndone")}
          </DialogDescription>
        </DialogHeader>

        <DialogFooter className="gap-2">
          <Button
            disabled={isLoading}
            variant="outline"
            onClick={() => onOpenClose(false)}
          >
            {t("cancel")}
          </Button>

          <Button
            className="min-w-24"
            disabled={isLoading}
            variant="destructive"
            onClick={() => handleDeleteP2PChat()}
          >
            {isLoading ? t("deleting") : t("delete")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
